import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const RISK_STYLES = {
  High: "bg-red-50 text-red-700 border-red-200",
  Medium: "bg-amber-50 text-amber-800 border-amber-200",
  Low: "bg-emerald-50 text-emerald-700 border-emerald-200",
};
export const RISK_BAR = { High: "bg-red-500", Medium: "bg-amber-400", Low: "bg-emerald-500" };
export const CONTRACT_STYLES = {
  NOT_SIGNED: "bg-slate-100 text-slate-600 border-slate-200",
  ACTIVE: "bg-emerald-50 text-emerald-700 border-emerald-200",
  EXPIRING: "bg-amber-50 text-amber-800 border-amber-200",
  EXPIRED: "bg-red-50 text-red-700 border-red-200",
  TERMINATED: "bg-slate-200 text-slate-700 border-slate-300",
};
export const REVIEW_STYLES = {
  DRAFT: "bg-slate-100 text-slate-600 border-slate-200",
  IN_PROGRESS: "bg-blue-50 text-[#008080] border-blue-200",
  SUBMITTED: "bg-purple-50 text-purple-700 border-purple-200",
  RETURNED: "bg-amber-50 text-amber-800 border-amber-200",
  APPROVED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  CANCELLED: "bg-slate-200 text-slate-600 border-slate-300",
};
export const CONTROL_STYLES = {
  MET: "text-emerald-700", PARTIAL: "text-amber-700", NOT_MET: "text-red-600", NA: "text-slate-400", PENDING: "text-slate-500",
};
export const ANSWER_STYLES = {
  YES: "bg-emerald-600 text-white border-emerald-600",
  PARTIAL: "bg-amber-500 text-white border-amber-500",
  NO: "bg-red-600 text-white border-red-600",
  NA: "bg-slate-500 text-white border-slate-500",
};
export const ANSWER_LABELS = { YES: "Yes", PARTIAL: "Partial", NO: "No", NA: "N/A" };
export const FACTOR_LABELS = {
  data_sensitivity_score: "Data sensitivity",
  record_volume_score: "Record volume",
  access_level_score: "Access level",
  business_criticality_score: "Business criticality",
  processing_position_score: "Processing position",
};

let cache = null;
export const useVendorMeta = () => {
  const [meta, setMeta] = useState(cache);
  const reload = useCallback(() => {
    api.get("/vendors/meta").then(({ data }) => { cache = data; setMeta(data); }).catch(() => {});
  }, []);
  useEffect(() => { if (!cache) reload(); }, [reload]);
  return meta;
};

export const scoreTone = (s) => (s == null ? "text-slate-400" : s >= 75 ? "text-emerald-600" : s >= 50 ? "text-amber-600" : "text-red-600");
